import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for configImage query
 */
export interface ConfigImageVariables {
  optionKey?: string;
  optionScope?: string;
}

/**
 * Configuration image node structure
 */
export interface ConfigImageNode {
  id: string;
  optionKey: string;
  optionValue: string | null;
  imageData: string | null;
}

/**
 * Configuration image edge structure
 */
export interface ConfigImageEdge {
  node: ConfigImageNode;
}

/**
 * All configurations with image connection structure
 */
export interface ConfigImageConnection {
  edges: ConfigImageEdge[];
}

/**
 * Response structure for configImage query
 */
export interface ConfigImageResponse {
  allConfigurations: ConfigImageConnection;
}

const configImage: DocumentNode = gql`
  query allConfigurations($optionKey: String, $optionScope: String) {
    allConfigurations(optionKey: $optionKey, optionScope: $optionScope) {
      edges {
        node {
          id
          optionKey
          optionValue
          imageData
        }
      }
    }
  }
`;

export default configImage;
